export default __webpack_public_path__ + "static/media/book.e2e67e90.jpg";